import { HttpDeleteParticipantService } from "./http-delete-participant.service";
import { catchError, map, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  	providedIn: 'root'
})

export class DeleteParticipantService {

    constructor(
        private httpDeleteParticipantService: HttpDeleteParticipantService
    ) { }

    public deleteParticipant$(participantID: string): Observable<boolean> {

        return this.httpDeleteParticipantService.deleteParticipant$(participantID).pipe(
            map(() => true),
            catchError(err => {
                console.error('[DeleteParticipantService] Error deleting the participant', err);
                return throwError(() => new Error('An error has occurred while trying to delete the participant'));
            })
        );

    }

}